import { createSelector } from "@reduxjs/toolkit";
import { selectHttpActiveFullMcbimSpace } from "../McBim/mcbimSelectors";
import { selectSectionCenterCoordinate } from "../ViewerRedux/viewerSlice";

type ICoordinate2D = [number, number];

export const getRoomSectionCoordinate = (
  polygon: number[][] | null | undefined
): ICoordinate2D | null => {
  if (!polygon || polygon.length < 4) {
    return null;
  }

  const xs = polygon.map((point) => point[0]);
  const ys = polygon.map((point) => point[1]);
  return [(Math.min(...xs) + Math.max(...xs)) / 2, (Math.min(...ys) + Math.max(...ys)) / 2];
};

// URL restoration selects a room without the drawing's click handler. Derive
// its initial section center when geometry arrives; preserve a dragged center.
export const selectRoomSectionCenterCoordinate = createSelector(
  [selectSectionCenterCoordinate, selectHttpActiveFullMcbimSpace],
  (coordinate, space): ICoordinate2D | null => coordinate ?? getRoomSectionCoordinate(
    space?.geometry?.polygon2d ?? space?.geometry?.bbox2d
  )
);
